import React, { useState, useEffect } from 'react'
import { ZoneIds } from '../../../hooks/kevelAPI/useKevelAnalytics'
import { createDataLayerIfNotExists } from '../../../utils/global/createDataLayerIfNotExists.js'
import { SearchRadiusInMeters } from '../../../constants/searchRadius'
import CenterCarousel from '../../molecules/CenterCarousel/CenterCarousel'
import { algoliaCenterSearch } from '@/lib/algoliaCenterSearch'
import { baseFilters } from '@/lib/constants'
const FeaturedCentersNearYou = ({ onCentersCountUpdate }) => {
  const [centers, setCenters] = useState([])
  const [centersLoading, setCentersLoading] = useState(true)

  // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
  useEffect(() => {
    const itemObjects = []
    const itemList = centers.map((node) => {
      return node
    })

    if (itemList.length !== 0) {
      createDataLayerIfNotExists()
      itemList.forEach((node, i) => {
        let singleObject = {}
        singleObject['item_name'] = node.title
        singleObject['item_id'] = node.slug
        singleObject['item_list_name'] = 'Featured Centers Block'
        singleObject['index'] = i + 1
        singleObject['item_category'] = window.location.href
        itemObjects.push(singleObject)
      })
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          items: itemObjects
        }
      })
    }
  }, [centers.hits])

  const handleDataLayerClick = (node, i) => {
    createDataLayerIfNotExists()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        items: [
          {
            item_name: node.title,
            item_id: node.slug,
            item_list_name: 'Featured Centers Block',
            index: i + 1,
            item_category: window.location.href
          }
        ]
      }
    })
  }

  useEffect(() => {
    algoliaCenterSearch({
      query: '',
      aroundLatLngViaIP: true,
      aroundRadius: 'all',
      filters: baseFilters.concat(' AND site:lux'),
      hitsPerPage: 20
    })
      .then(({ hits }) => {
        setCenters(hits)
        setCentersLoading(false)
        if (onCentersCountUpdate) {
          onCentersCountUpdate(hits.length)
        }
      })
      .catch((e) => {
        console.log('error', e)
      })
  }, [])

  return (
    <CenterCarousel
      centers={centers}
      isLoading={centersLoading}
      onCenterClick={handleDataLayerClick}
      hideDescription={true}
      zoneId={ZoneIds.Featured}
      sectionHeading="Centers Near You"
      headerSize="2xl"
      headerWeight="medium"
      useFieldsVariable={true}
      containerId="featuredCentersNearYou"
    />
  )
}

export default FeaturedCentersNearYou
